var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86 18.06C9.77 18.06 9.68 18.04 9.59 18.01C9.3 17.9 9.11 17.62 9.11 17.31V13.39H0.75C0.34 13.39 0 13.05 0 12.64V5.31C0 4.9 0.34 4.56 0.75 4.56H9V0.810003C9 0.500003 9.19 0.220003 9.48 0.110003C9.77 2.75299e-06 10.1 0.0800027 10.31 0.310003L17.81 8.56C18.07 8.84 18.07 9.28 17.81 9.57L10.42 17.82C10.27 17.98 10.07 18.07 9.86 18.07V18.06ZM1.5 11.89H9.86C10.27 11.89 10.61 12.23 10.61 12.64V15.35L16.24 9.06L10.5 2.75V5.31C10.5 5.72 10.16 6.06 9.75 6.06H1.5V11.89Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.56C4.5 10.97 4.84 11.31 5.25 11.31C5.66 11.31 6 10.97 6 10.56V7.56C6 7.15 5.66 6.81 5.25 6.81C4.84 6.81 4.5 7.15 4.5 7.56V10.56Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.81C2.25 10.22 2.59 10.56 3 10.56C3.41 10.56 3.75 10.22 3.75 9.81V8.31C3.75 7.9 3.41 7.56 3 7.56C2.59 7.56 2.25 7.9 2.25 8.31V9.81Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutline);
export default __webpack_public_path__ + "static/media/arrow-outline.069cd5564365b8b7c2268c495de9499b.svg";
export { ForwardRef as ReactComponent };